const STORAGE_PREFIX = 'league_chat_last_seen_';

export function getLastSeenTimestamp(leagueId: string): string | null {
  return localStorage.getItem(`${STORAGE_PREFIX}${leagueId}`);
}

export function setLastSeenTimestamp(leagueId: string, timestamp: string): void {
  localStorage.setItem(`${STORAGE_PREFIX}${leagueId}`, timestamp);
}

export function hasUnreadMessages(leagueId: string, latestMessageAt: string | null): boolean {
  if (!latestMessageAt) return false;
  const lastSeen = getLastSeenTimestamp(leagueId);
  if (!lastSeen) return true;
  return new Date(latestMessageAt) > new Date(lastSeen);
}
